import { atom } from "@mongez/react-atom";
import { LessonDetails } from "../types";

export const lessonAtom = atom<LessonDetails>({
  key: "lesson",
  default: {},
});
